/**
 * CSV-Export der aktuellen Ansicht: Semikolon-getrennt und mit BOM, damit ein
 * deutsches Excel die Datei per Doppelklick richtig öffnet (Komma-CSV landet
 * dort in einer einzigen Spalte, ohne BOM zerfallen die Umlaute).
 */

const BOM = '\uFEFF';

export function baueCsv(spalten: string[], zeilen: Array<Array<string | number | null | undefined>>): string {
  const feld = (wert: string | number | null | undefined): string => {
    const text = wert === null || wert === undefined ? '' : String(wert);
    return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const inhalt = [spalten, ...zeilen].map((zeile) => zeile.map(feld).join(';')).join('\n');
  return BOM + inhalt;
}

export function ladeCsvHerunter(dateiname: string, spalten: string[], zeilen: Array<Array<string | number | null | undefined>>): void {
  const blob = new Blob([baueCsv(spalten, zeilen)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = dateiname;
  a.click();
  URL.revokeObjectURL(url);
}
